import { useEffect, useState } from 'react';
import {
  formatDate,
  IconEdit,
  Textarea,
  ButtonSecondary,
  ButtonSize,
  IconLoader,
  IconTrash,
} from '@ui/src';
import {
  useEditCustomersCommentMutation,
  useDeleteCustomersCommentMutation,
} from '../../../store/documents/services';
import { DocumentCommentTypes } from './types';

import cn from './documents.module.css';

const DocumentComment = ({
  comment,
  documentId,
  commentsVisible,
}: DocumentCommentTypes) => {
  const [edit, setEdit] = useState(false);
  const [text, setText] = useState(comment.text);

  const [editComment, { isLoading, isSuccess }] =
    useEditCustomersCommentMutation();
  const [deleteComment, { isLoading: deleteInProgress }] =
    useDeleteCustomersCommentMutation();

  useEffect(() => {
    if (comment) {
      setText(comment.text);
    }
  }, [comment]);

  useEffect(() => {
    if (isSuccess) {
      setEdit(false);
    }
  }, [isSuccess]);

  let content;

  if (!edit) {
    content = (
      <div className={cn.documentSidepanelComment}>
        <div className={cn.documentSidepanelCommentTop}>
          <div className={cn.documentSidepanelCommentTopLeft}>
            <div>{`${comment?.user?.profile?.firstName} ${comment?.user?.profile?.lastName}`}</div>
            <div>
              {`${
                comment.updatedAt !== comment.createdAt ? 'updated at' : ''
              } ${formatDate(
                comment.updatedAt !== comment.createdAt
                  ? comment.updatedAt
                  : comment.createdAt,
                true,
              )}`}
            </div>
          </div>
          {commentsVisible && (
            <div className={cn.documentSidepanelCommentTopRight}>
              <button
                type="button"
                className={cn.documentEditButton}
                onClick={() => setEdit(true)}
                aria-label="Edit button"
              >
                <IconEdit width={16} height={16} />
              </button>
              <button
                type="button"
                className={cn.documentDeleteButton}
                aria-label="Delete button"
                onClick={() =>
                  deleteComment({
                    id: documentId as string,
                    commentId: comment.id,
                  })
                }
              >
                {deleteInProgress ? (
                  <IconLoader width={16} height={16} />
                ) : (
                  <IconTrash width={16} height={16} />
                )}
              </button>
            </div>
          )}
        </div>
        <div className={cn.documentSidepanelCommentText}>{comment.text}</div>
      </div>
    );
  } else {
    content = (
      <div className={cn.documentEditWrapper}>
        <Textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          name="text"
          className={cn.documentEditTextarea}
          placeholder="Comment text..."
        />
        <div className={cn.documentEditControls}>
          <ButtonSecondary
            className={`button-white ${cn.documentEditSubmit}`}
            disabled={!text || isLoading}
            onClick={() => {
              setText('');
              editComment({
                id: documentId as string,
                commentId: comment.id,
                body: {
                  text,
                },
              });
            }}
            text={isLoading ? 'Loading...' : 'Edit'}
            size={ButtonSize.SMALL}
          />
          <ButtonSecondary
            className={`button-white ${cn.documentEditSubmit}`}
            onClick={() => setEdit(false)}
            text="Cancel"
            size={ButtonSize.SMALL}
          />
        </div>
      </div>
    );
  }

  return content;
};

export default DocumentComment;
